import { jsx as _jsx } from "react/jsx-runtime";
import { MessageAddOutlinedIcon } from '@getgo/chameleon-icons/react';
import { Alert } from '@getgo/chameleon-web-react-wrapper';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { fullName } from "../../utils/user";
import classes from './CreatedByInfo.module.scss';
import TextTime from './TextTime';
const CreatedByInfo = ({ currentUserId, createdBy, fullWidth, compact, displayFullDate, }) => {
    const { t } = useTranslation();
    const text = currentUserId === createdBy.id
        ? t('This conversation was created by you')
        : t('This conversation was created by {{by}}', {
            by: fullName(createdBy),
        });
    return (_jsx("div", Object.assign({ role: "listitem", className: classNames(classes.content, {
            [classes.fullWidth]: fullWidth,
            [classes.compact]: compact,
        }) }, { children: _jsx(Alert, Object.assign({ icon: _jsx(MessageAddOutlinedIcon, {}, void 0), variant: "info", className: classes.alert, "data-testid": 'conversation-creation-alert' }, { children: _jsx(TextTime, { text: text, time: createdBy.createdAt, displayFullDate: displayFullDate }, void 0) }), void 0) }), void 0));
};
export default CreatedByInfo;
//# sourceMappingURL=CreatedByInfo.js.map